<template>
    <div>
        <b-sidebar
            v-if="isSideBarOpenInsurance"
            v-model="isSideBarOpenInsurance"
            id="sidebar-right"
            title="Добавление страхования"
            right
            backdrop
            shadow
            width="65em"
            backdrop-variant="dark"
            no-close-on-backdrop
            @change="closeSidePanelCallback()"
        >
            <div class="d-block">
                <form class="needs-validation mb-1 mt-4" novalidate id="insuranceForm">
                    <div class="d-flex mb-4" style="justify-content: space-between;">
                        <h5 class="my-0">Основная информация</h5>
                        <div>
                            <b-form-checkbox 
                                v-model="editedItem.is_available" 
                                id="is_available" 
                                name="is_available" 
                                switch 
                                class="mt-0 ml-3"
                                :value="1"
                                :unchecked-value="0"                                
                            >
                                <b>Полис в наличии</b>
                            </b-form-checkbox>
                        </div>
                    </div>
                    <div class="form-row">
                        <div class="form-group col-md-6">
                            <label for="insurance_type_id">Тип страхования</label>
                            <tsoft-select-of-properties
                                :reference_id="83"
                                :needNullElement="false"
                                :needMultipleSelect="false"
                                :internalSearch="false"
                                :selected="editedItem.insurance_type_id"
                                @set="setInsuranceType"
                            ></tsoft-select-of-properties>
                        </div>
                        <div class="form-group col-md-6">
                            <label for="policy_number">№ полиса</label>
                            <input v-model="editedItem.policy_number" type="text" required class="form-control" id="policy_number">
                        </div>
                    </div>
                    <div class="form-row">
                        <div class="form-group col-md-6">
                            <label for="policy_date">Дата полиса</label>
                            <input v-model="editedItem.policy_date" type="date" required class="form-control" id="policy_date">
                        </div>
                        <div class="form-group col-md-6">
                            <label for="policy_expiry">Срок действия полиса</label>
                            <input v-model="editedItem.policy_expiry" type="date" required class="form-control" id="policy_expiry">
                        </div>
                    </div>
                    <div class="form-row">
                        <div class="form-group col-md-4">
                            <label for="policy_limit">Лимит по полису</label>
                            <input v-model="editedItem.policy_limit" type="number" step="0.01" required class="form-control" id="policy_limit">
                        </div>
                        <div class="form-group col-md-4">
                            <label for="case_limit">Лимит по разовому случаю</label>
                            <input v-model="editedItem.case_limit" type="number" step="0.01"  required class="form-control" id="case_limit">
                        </div>
                        <div class="form-group col-md-4">
                            <label for="franchise_limit">Франшиза, лимит</label>
                            <input v-model="editedItem.franchise_limit" type="number" step="0.01" required class="form-control" id="franchise_limit">
                        </div>
                    </div>
                    <div class="form-row">
                        <div class="form-group col-md-6">
                            <label for="scan_id">Скан полиса</label>
                            <b-form-file
                                v-model="editedItem.new_scan"
                                :state="Boolean(editedItem.new_scan)"
                                :placeholder="editedItem.scan ? 'Обновить файл':'Выберите файл...'"
                                drop-placeholder="Отпускайте файл..."
                            ></b-form-file>
                            <small v-if="editedItem.scan && !editedItem.new_scan">
                                Документ уже был загружен, <a :href="hfs+editedItem.scan.path" target="_blank">посмотреть &raquo;</a>
                            </small>
                        </div>
                    </div>
                </form>
            </div>
            <template #footer>
                <div class="row">
                    <div class="col-9">

                    </div>
                    <div class="col-3 text-right">
                        <button class="btn btn-outline-primary" @click="submitForm($event)">Сохранить<i class="fas fa-spinner fa-spin ml-1" v-if="savingProcess"></i></button>
                    </div>
                </div>
            </template>
        </b-sidebar>
    </div>
</template>

<script>
    import { API_COMPANY_INSURANCE, HOST_FOR_STORAGE } from "../../constants"

    import {
        typeOfCompany,
        maxCharsLimit,
        defaultDataItems,
        buildFormData,
        typeOfTCLoadingList,
        changeCommasOnDots,
        filterTSNames,
        validGosNumber
    } from '../../mixins'

    export default {
        props: {
            isSideBarOpenInsurance: { type: Boolean, required: false },
            editIndex: { type: Number || String, required: false, default: -1 },
            editedItemExt: { type: Object, required: false },
            companyId: { type: Number, required: false, default: -1 }
        },
        mixins: [
            typeOfCompany,
            maxCharsLimit,
            defaultDataItems,
            buildFormData,
            typeOfTCLoadingList,
            changeCommasOnDots,
            filterTSNames,
            validGosNumber
        ],
        data() {
            return {
                tableApiUrl: API_COMPANY_INSURANCE,
                savingProcess: false,
                hfs: HOST_FOR_STORAGE,
                selectedCompanyId: '',
                selectedCompany: {},
            }
        },
        watch: {
            'editedItemExt': function (editedItem){
                this.onItemEditModalCallback()
            },
        },
        computed: {
            isSideBarOpenInsuranceLocal: {
                get: function() {
                    return this.isSideBarOpenInsurance
                },
                set: function(value) {
                    this.$emit('update:isSideBarOpenInsurance', value)
                }
            },
            editedItem: {
                get: function() {
                    return this.editedItemExt
                },
                set: function(value) {
                    this.$emit('update:editedItemExt', value)
                }
            }
        },
        mounted() {
        },
        methods: {
            submitForm(event) {
                event.preventDefault()
                let form = document.getElementById("insuranceForm")
                if (form.checkValidity() === false) {
                    event.preventDefault()
                    event.stopPropagation()
                    form.classList.add('was-validated')
                    return false
                }
                this.createOrUpdateItem()
            },
            createOrUpdateItem() {
                this.savingProcess = true
                if (typeof this.onCreateOrUpdateItemCallback === 'function') {
                    this.onCreateOrUpdateItemCallback()
                }

                const formData = new FormData()
                this.buildFormData(formData, this.editedItem)

                if (this.editIndex == -1) {
                    formData.append('company_id', this.companyId)
                    formData.set('is_available', this.editedItem.is_available ? 1 : 0) // Ensure boolean is sent as integer

                    api.call("post", this.tableApiUrl, formData, {
                        headers: {
                            "Content-Type": "multipart/form-data"
                        }
                    }).then(({data}) => {
                        this.$emit('create', data)
                        this.savingProcess = false
                        this.isSideBarOpenInsuranceLocal = false
                        this.makeToast('success', 'Страхование добавлено')
                    }).catch((response) => {

                    })
                } else {
                    formData.append('_method', 'PUT')
                    formData.set('is_available', this.editedItem.is_available ? 1 : 0) // Ensure boolean is sent as integer

                    api.call("post", `${this.tableApiUrl}/${this.editedItem.id}`, formData, {
                        headers: {
                            "Content-Type": "multipart/form-data"
                        }
                    }).then(({data}) => {
                        this.$emit('update', data)
                        this.savingProcess = false
                        this.isSideBarOpenInsuranceLocal = false
                        this.makeToast('info', 'Изменения сохранены')
                    }).catch((response) => {

                    })
                }
            },
            // calls from mixin on item edit
            onItemEditModalCallback() {
                this.selectedCompanyId = ''
                this.cleanCompanyInfo()
            },
            // calls from mixin on item save
            onCreateOrUpdateItemCallback() {
            },
            closeSidePanelCallback() {
                this.$emit('closeSidePanel')
            },
            addCompanyToList() {
                this.editedItem.companies.unshift({
                    id: this.selectedCompany.id,
                    name: this.selectedCompany.name,
                    inn: this.selectedCompany.inn,
                })
                this.selectedCompanyId = ''
                this.cleanCompanyInfo()
            },
            deleteCompanyFromList(index) {
                this.editedItem.companies.splice(index, 1)
            },
            cleanCompanyInfo() {
                for (const prop of Object.getOwnPropertyNames(this.selectedCompany)) {
                    delete this.selectedCompany[prop]
                }
            },
            setCompany(id, selectedCompany) {
                if (selectedCompany != null && selectedCompany.id) {
                    this.selectedCompanyId = id
                    this.selectedCompany = { ...selectedCompany }
                }
            },
            setInsuranceType(value) {
                this.editedItem.insurance_type_id = value
            },
            setDocument(id, selectedDocument) {
                if (selectedDocument != null && selectedDocument.id) {
                    this.editedItem.scan_id = id
                }
            }
        }
    }
</script>
<style scoped>
    .big-add-button {
        height: 50px;
    }
    .custom-select {
        line-height: 32px;
        height: 50px;
        border-radius: 1px;
    }
</style>
